import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import Header from '../../views/common/Header';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import BrowserUtil from '../../util/BrowserUtil';

import '../../mdl/materialUsage.css';
import '../../home/style.violet.css';
import '../../home/custom.css';
import '../../css/landing.css';
import '../../css/myHome.css';


import '../../views/common/Sidebar';
import '../../vendors/mindstretcher/ms_sidebar';
import '../../vendors/prep/prep_sidebar';
//import Ms_sidebar from '../../vendors/mindstretcher/ms_sidebar';
//import Sidebar from '../../views/common/Sidebar';
/*
* IMPORTANT: Reason for commenting the variable-based importing is to avoid accidental usage which 
* could break the dependency injection (Component Registry) flow
*
*/

class Landing extends LoggedInPage{
	
	constructor(props) {
	 super(props);
	 
	 this.state = {	
			 visible:false,
			 topicListPlaceHolder:"",
			 upgradenow:false
     	};
	 
	 
	 this.childComponent = null;
	 this.childComponentName = null;
	 
	 this.userNameUpdateEvent = this.userNameUpdateEvent.bind(this);
	 this.updateImage = this.updateImage.bind(this);
	 this.sideBarDropdownChange = this.sideBarDropdownChange.bind(this);
	 this.routingMenus = this.routingMenus.bind(this);
	 this.loginStoreKey="PLP_LOGIN_INFO";	 
	 this.homeDropDownKey = "homeDropdown";
	 this.gradeStore = null;

	 this.renderSidebar=this.renderSidebar.bind(this);
     };
	 
    setChild(childComp,childName){
    	this.childComponent = childComp; 
    	this.childComponentName = childName;
    } 
    
	componentDidMount(){
		this.sessionCheck();
		this.loginTracking();
	} 

	getAccessIdsforProducts(){
		var accessIds = [];
		var prodAccess = ["PLP|REVISION|TAKE","PLP|LESSON|VIEW"];
		var user = this.getUser();

		if(user.getAccessMap()){
			for(var i in user.getAccessMap()){
				if(prodAccess.indexOf(user.getAccessMap()[i]) >= 0){
					accessIds.push(i);
				}
			}
		}

		return accessIds;
	}

	getClassIdforAccessCount(classId){
		var accessIds = this.getAccessIdsforProducts();
		var user = this.getUser();

		var counter = 0;
		if(user.getPermissions() && accessIds){
			//var classId = 4;
	
			for(var i in user.getPermissions()){
			 try{
				 if(accessIds.indexOf(i) && user.getPermissions()[i].indexOf(classId)){
					 counter ++;
				}
			 }catch(e){
			 }		
			}
	
		}
	
		return counter;	
	}



	routingMenus(value){
		try{
			// this.gradeStore = {
			// 	"grd":this.selectedGradeOption.value,
			// 	"prod":this.selectedProductOption.value
			// }
			//this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));
		}catch(e){}
		
		this.props.history.push(value);
	}
	loginTracking(){
		try{
			var loginInfo = BrowserStorageUtil.getStoredSessionItem(this.loginStoreKey);		
			//console.log("loginInfo:::",loginInfo);
			if(loginInfo){
				this.initiateTrack("login",JSON.parse(loginInfo));
				BrowserStorageUtil.removeSessionItem(this.loginStoreKey);
			}
		}catch(e){}
	}
	userNameUpdateEvent(username){	
		this.sidebarComponent.updateUserName(username);
	}
	
	updateImage(imageUrl){
		if(imageUrl){
			this.sidebarComponent.setCurrentImage(imageUrl);
		}else{
			this.sidebarComponent.deleteCurrentImage();
		}
	}

	sideBarDropdownChange(selectedGradeOption,selectedProductOption,comboNamesLoaded,state,isProductClicked){
		console.log("selected product:::",selectedGradeOption," :::: " ,selectedProductOption);
		if( this.childComponent && this.childComponent.assignStateFromParent){
			this.childComponent.selectedProductOption = selectedProductOption;
			this.childComponent.selectedGradeOption = selectedGradeOption;
			this.childComponent.comboNamesLoaded = comboNamesLoaded;
			this.childComponent.assignStateFromParent(state);
			
			if(state.noProducts == false){
				this.childComponent.getTopicList();
			}
		}else{
			if(this.childComponentName == "DASHBOARD" && !isProductClicked){
				this.childComponent.gradeDropdownChange(selectedGradeOption);
			}
		}
		
		// this.setState({upgradenow:false});
	}	

	renderSidebar(){
		var mindstretcher=true;
		var me=this;

		let SideBarComp = me.getComponent("Sidebar");
		return (
			<SideBarComp onRef={ref => (me.sidebarComponent = ref)} myProps={me.props} sideBarDropdownChange={me.sideBarDropdownChange} childComponentName={me.childComponentName} routingMenus={me.routingMenus}/>
			)
	}

  render(subComponent) {	
  	  if(!this.state.loggedIn){
  	  	return super.render();
  	  }else{
  	  	return (
		<div className="page">
			
			  {/*<Header />*/}
			  
			  <div className="page-content d-flex align-items-stretch"> 
				{this.renderSidebar()}
				<div className="content-inner">	
				
					<div className="container-fluid norightpadding">
					{/* <SubscribeButton></SubscribeButton>	 */}
						{subComponent}
					</div>
				</div>
			  </div>
			 
			  
		</div>
	    );
  	  }
  
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/views/common/Landing.js